import { AxiosResponse } from "axios"
import { apiUrl } from "../helpers/constants/config.constants"
import { httpDelete, httpGet, httpPost, httpPut } from "./http.service"

export type RewardPointModel = {
  rewardPointsId: string
  projectId: string
  userId: string
  totalPurchase: number
  points: number
  rewardType: string
  sourceId: string
  sourceType: string
  description: string
  isActive: boolean
  expiredAt: Date
  metadata: string
  createdBy: string
  createdAt: Date
  updatedBy: string
  updatedAt: Date
  deletedAt: Date
}

export const doListRewardPoint = (skip: number) => {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.reward.list, { skip }).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  });
}

export const doGetRewardPoint = (rewardPointsId: string) => {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.reward.get(rewardPointsId)).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  });
}

export const doCreateRewardPoint = (params: any) => {
  return new Promise((resolve, reject) => {
    httpPost(apiUrl.reward.create, params).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  });
}

export const doUpdateRewardPoint = (params: any) => {
  return new Promise((resolve, reject) => {
    httpPut(apiUrl.reward.update(params.rewardPointsId), params).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  });
}

export function doDeleteRewardPoint(rewardPointsId: string) {
  return new Promise((resolve, reject) => {
    httpDelete(apiUrl.reward.delete(rewardPointsId)).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  });
}

export function doGetCampaignList() {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.campaign.list).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  })
}